import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import FeedPage from "@/components/feed/feed-page";

const FeedRoutePage = (): JSX.Element => <FeedPage />;

export const Route = createFileRoute("/_app/feed/")({
	component: FeedRoutePage,
});
